/**
 * Marquee behavior
 *
 */

document.querySelectorAll('.js-marquee-scrollable')?.forEach((marquee) => {
	let startX = 0;
	const start = (e) => {
		startX = e.changedTouches[0].clientX;
	};
	marquee.addEventListener('touchstart', start);
	const end = (e) => {
		const endX = e.changedTouches[0].clientX;
		if (Math.abs(endX - startX) > 100) {
			marquee.removeEventListener('touchstart', start);
			marquee.removeEventListener('touchend', end);
			marquee.classList.add('marquee--scroll');
		}
	};
	marquee.addEventListener('touchend', end);
});
